<div *ngIf="placeholder" class="placeholder"></div>
<div *ngIf="icon && !(previewURL$ | async)" class="image-container icon-placeholder d-flex align-items-center justify-content-center">
  <mat-icon>{{ icon }}</mat-icon>
</div>
<div *ngIf="attachment$ | async" class="image-container">
  <div *ngIf="previewURL$ | async as previewURL" class="preview image" [style.background-image]="'url(' + previewURL + ')'"></div>
  <ng-container *ngIf="showOriginalURL$ | async">
    <div *ngIf="downloadURL$ | async as downloadURL" [style.background-image]="'url(' + downloadURL + ')'" class="image"></div>
  </ng-container>
  <div *ngIf="thumbnailURL$ | async as thumbnailURL" [style.background-image]="'url(' + thumbnailURL + ')'" class="image"></div>
</div>
<ng-container *ngIf="!(downloadURL$ | async)">
  <ng-container *ngIf="!progressType || progressType === 'progress-bar'">
    <mat-progress-bar *ngIf="percentage$ | async as percentage" [value]="percentage | number"></mat-progress-bar>
  </ng-container>
  <div *ngIf="progressType === 'progress-spinner'" class="progress-spinner-container d-flex align-items-center justify-content-center">
    <mat-progress-spinner *ngIf="percentage$ | async as percentage" mode="determinate" [value]="percentage | number" [diameter]="diameter"></mat-progress-spinner>
  </div>
</ng-container>